import { Helmet } from "react-helmet";
import PolicyLayout from "../sections/policy/policyLayout";
import privacyPolicyData from '../assets/data/privacyPolicy.json';

const PrivacyPolicyPage = () => {
    return (
        <>
            <Helmet>
                <title>code3x Privacy Policy | Data & User Protection</title>
                <meta name="description" content="code3x values your privacy. Learn about our policies for data collection, storage, and security." />
                <meta name="keywords" content="code3x privacy policy, data protection, user privacy, privacy in AI, digital solutions policy" />
                <link rel="canonical" href="https://code3x.tech/privacy-policy" />
            </Helmet>

            <PolicyLayout data={privacyPolicyData}/>
        </>
    );
}

export default PrivacyPolicyPage;